import { useMutation } from '@apollo/client'
import { ApproveTestSession, ApproveTestSessionVariables } from '../../types'
import { APPROVE_TEST_SESSION } from './operations'

export const useAproveTestSession = () =>
  useMutation<ApproveTestSession, ApproveTestSessionVariables>(APPROVE_TEST_SESSION)
